const csvCell = (value) => {
  const text = String(value ?? "");
  const safe = /^[\s]*[=+@-]/.test(text) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
};

export const chartCsv = (headers, rows) => [headers, ...rows]
  .map((row) => row.map(csvCell).join(","))
  .join("\r\n");

export const downloadChartCsv = (name, headers, rows) => {
  const blob = new Blob(["\uFEFF", chartCsv(headers, rows)], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `${name}.csv`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};
